import { useEffect, useState, useContext, useRef} from 'react'
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import './css/Cp.css'
import { AppContext } from "../Context";
import Fetch, { Loader, dateToText } from "../inc/Fetch";
import Randlet, { Img, Question } from "../components/Elements";

import Footer from "./Footer";
import Header from "./Header";
import SendTask from "./popups/SendTask";
import { Input } from "../components/Form";

import { RiQuestionAnswerLine } from "react-icons/ri";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
import { MdDeleteOutline, MdEdit, MdOutlineGroup, MdOutlineQuestionAnswer } from "react-icons/md";
import Checkbox from './questions/Checkbox';
import Options from './questions/Options';
import Missing from './questions/Missing';
import Sorting from './questions/Sorting';
import TextQuestion from './questions/Text';
import MissingNew from './questions/MissingNew';


export default function MyTasks() {

	const { t } = useTranslation();
	const {success, userinfo} = useContext(AppContext);
	const [open, setopen] = success;
	const [logedIn, setlogedIn] = userinfo;

	const [loader, setloader] = useState(true);
	const [loader2, setloader2] = useState(false);
	const [data, setdata] = useState([]);
	const [showsendTask, setshowsendTask] = useState(false); 
	const [values, setvalues] = useState({});

	let loc = useParams();
	let nav = useNavigate();

	let selectEd = [
		{
			name: "نهائي",
			val:1
		},
		{
			name: "بانتظار التصليح",
			val:0
		}
	]

	function submit() {

		setloader2(true);
		Fetch("tasks/updateScore", (d) => {

			if (d?.error) {
				setopen({
                    short:d?.error,
                    error:true
                });
			} else {
				setopen({
                    short:"تم تعديل علامة الطالب بنجاح.",
                    error:false
                });

				setTimeout(() => {
					nav(-1);
				}, 2500);
			}

			
			setloader2(false);
		}, values);
	}

	useEffect(() => {
			
		Fetch("tasks/view", (d) => {

			if (!d?.error) {

				setdata(d);
				setvalues(p => ({
					finished: d?.tasks[0]?.students[0]?.finished || false,
					score:d?.tasks[0]?.students[0]?.score,
					_id: loc?.id,
					student: loc?.student,
				}))
			}
			
			setloader(false);
		}, { _id: loc?.id, student:loc?.student});

	
	}, []);


	if (loader) {
		return (
			<Loader />
		);
	}

	let path = [
		{
			name:"Home",
			link:"/"
		},
		{
			name:"My Tasks",
			link:"/MyTasks"
		},
		{
			name:data?.tasks[0]?.name,
			link:`/MyTasks/${loc?.id}`
		},
		{
			name:data?.tasks[0]?.students[0]?.name,
			link:`/MyTasks/${loc?.id}/${loc?.student}`
		}
	];
	

	return (
		
		<>
			{loader2 && <Loader />}
			<Header />


			<div className='firstElem stats' style={{marginTop:-30}}>

				<div className='mainWidth'>


					<section>
						<div>
							<b>عدد الاسئلة</b>
							<h3>{data?.tasks[0]?.questions?.length}</h3>
							{/* <span className='up'><FaArrowUp /> 10.3%</span> */}
						</div>
					</section>

					<section>
						<div>
							<b>معدل العلامة</b>
							<h3>{data?.stats?.avg}%</h3>
							{/* <span><FaArrowDown /> 2.3%</span> */}
						</div>
					</section>

					<section>
						<div>
							<b>توقيت الانتهاء</b>
							<h3 style={{fontSize:38}}>{data?.tasks[0]?.students[0]?.timer}</h3>
							{/* <span><FaArrowUp /> 1.3%</span> */}
						</div>
					</section>
					<section>
						<div>
							<b>حالة المهمة</b>
							<h3 style={{fontSize:38}}>{values?.finished ? "نهائي" : "بانتظار التصليح"}</h3>
							{/* <span><FaArrowUp /> 1.3%</span> */}
						</div>
					</section>


				</div>
			</div>


			<div className='body'>
				<div className='mainWidth '>

					<div className='cp'>

						

						<div className='containerBox' style={{flex:1, paddingTop:10 }}>
					
		
							<h3 className='boxTitle' style={{fontSize:20, color:"#555"}}>الاسئلة</h3>

							<div className='quizPrevBox' style={{height:"auto", marginTop:20, }}> 
								<div className='questionsBox' style={{overflow:"unset", padding:"30px", border:0}}>

									<div className='question'>
										<div dangerouslySetInnerHTML={{__html:`${data?.tasks[0]?.story}`}} style={{padding:20}}></div>
									</div>

									{data?.tasks[0]?.questions?.map((v, k) => {

                                        console.log(data);
                                        
                                        
                                        let myAnswers = data?.tasks[0]?.students[0]?.answers?.filter(r => r?.ID == v?.ID); 
										if (myAnswers?.length) {
											myAnswers = myAnswers[0];
										}

                                        
										let showAllAnswers = false;
										return (
											<div className='questionsBoxQ'>
												{v?.notes && <p className='noteBox'>{v?.notes}</p>}
												{v?.type == 1 && <h3>{v?.question}</h3>}
												{v?.type == 2 && 
													<div key={k} className='qVideoPlayer'>
														<iframe  src={`https://www.youtube.com/embed/${yID}`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
														<h3>{v?.video?.video_title}</h3>
														<p>{v?.video?.video_desc}</p>
													</div>
												}
												{v?.type == 3 && 
													<div key={k} className='qVideoPlayer'>
														<audio controls style={{width:"100%"}}>
															<source src={`${Config?.imgUrl}${v?.file?.file}`} type="audio/mpeg" />
														</audio>
														<h3>{v?.file?.file_title}</h3>
														<p>{v?.file?.file_desc}</p>
													</div>
												}
												{v?.type == 4 && 
													<div key={k} className='qVideoPlayer'>
														<img style={{width:"100%", aspectRatio:16/9, objectFit:"cover", borderRadius:10, border:"1px solid #eee"}} src={`${Config?.imgUrl}${v?.file?.file}`} />
														<h3>{v?.file?.file_title}</h3>
														<p>{v?.file?.file_desc}</p>
													</div>
												}
												{v?.type == 5 && 
													<div key={k} className='qVideoPlayer'>
														<SpeackBtn text={v?.file?.file_word} />
														<h3>{v?.file?.file_title}</h3>
														<p>{v?.file?.file_desc}</p>
													</div>
												}

												{!v?.answersType && 

													<Options
														v={v}
														student_answer={myAnswers?.answer}
														// showAllAnswers={showAllAnswers}
													/>
									
												}

												{v?.answersType == 2 && 

													<div className='answersBox' >
														<Checkbox
														 	student_answer={myAnswers?.answer}
														 	v={v}
														/>
													</div>
													
												}
												{v?.answersType == 3 && 

													<div className='answersBox' >
														<TextQuestion
                                                            v={v}
                                                            student_answer={myAnswers?.answer}
                                                        />
													</div>
													
												}
												{v?.answersType == 4 && 

													<div className='answersBox' >
														<MissingNew
                                                            v={v}
                                                            student_answer={myAnswers?.answer}
                                                        />
													</div>
													
												}

                                                
{/* 

												{v?.answersType == 3 &&  

													<div className='answersBox' >
														<Missing
															student_answer={myAnswers?.answers}
															v={v}
															showAnswers={showAllAnswers}
														/>
													</div>

												}

												{v?.answersType == 4 &&  
													<div className='answersBox'>
														<div className='sortingBox'>
															<Sorting
																student_answer={myAnswers?.answers}
																v={v}
																showAnswers={showAllAnswers}

															/>
														</div>
													</div>

												} */}

												{/* <div className='btnSection' style={{justifyContent:"flex-end"}}>
										
													<a href='javascript:void(0)' onClick={() => setstep(p => p - 1)} className='btn gray'>{text?.back}</a>
													
													{data?.task?.questions?.length == step ?
														<>

														{!already?.finished && <a onClick={() => submit()} className='btn'>{text?.send_quiz_now}</a>}
														</>
													:
														<a href='javascript:void(0)' onClick={() => setstep(p => p + 1)} className='btn'>{text?.next} {text?.question}</a>
													}
												</div> */}

											</div>
										);
										// return (
										// 	<Question v={v} answers={ans} key={k} />
										// );
										
									})}

									
									
								</div>

								<div className='questionComments'>
									<div>
										<Input 
											title="العلامة" 
											name="user"
											type="number"
											onChange={(v) => setvalues(p => ({
												...p,
												score:v,
											}))}
											value={values?.score}

										/>
									</div>

									<div style={{display:"flex", alignItems:"flex-end"}}>
										<Input 
											title="الحالة" 
											name="user"
											type="select"
											onChange={(v) => setvalues(p => ({
												...p,
												finished:v,
											}))}
											value={values?.finished ? 1 : 0}
											values={selectEd}
											style={{width:200}}
										/>

										<button type="button" onClick={submit} className='btn'>حفظ النتائج</button>
									</div>
									
								</div>

								
							</div>
							
						</div>

						<div className='containerBox' style={{width:"30%", paddingTop:10}}>
						
							<h3 className='boxTitle' style={{fontSize:20, color:"#555"}}>معلومات المهمة</h3>

							<div className='quizInfoBox' >
								<ul>
									<Img src={data?.tasks[0]?.students[0]?.img} />
									<h3>{data?.tasks[0]?.students[0]?.name}</h3>
									<h4>{global.Classes[data?.tasks[0]?.students[0]?.classes[0][0]]} ({global.Grades[data?.tasks[0]?.students[0]?.classes[0][2]]})</h4>
								</ul>
							</div>

							<div className='quizInfoBox'>
								<a>
									<span>الصفوف</span>
									<b>
										{data?.tasks[0]?.classes?.map((v, k) => {
											
											let classNames = global.Classes[v[0]];
											let gradeNames = global.Grades[v[2]];

											return (
												<r key={k}>{classNames} ({gradeNames}), </r>
											);
										})}
									</b>
								</a>
								
								<a>
									<span>التوقيت</span>
									<b>{data?.tasks[0]?.timer ? `${data?.tasks[0]?.timer} دقائق` : "غير محدود"}</b>
								</a>
								<a>
									<span>النتيجة</span>
									<b>{data?.tasks[0]?.res_type ? "تصليح تلقائي" : "تصليح من المعلم"}</b>
								</a>

								<a>
									<span>اضيف ب</span>
									<b>{dateToText(data?.tasks[0]?.time)}</b>
								</a>
								<a>
									<span>بدأ ب</span>
									<b>{dateToText(data?.tasks[0]?.date_start)}</b>
								</a>
								<a>
									<span>ينتهي ب</span>
									<b>{data?.tasks[0]?.date_end ? dateToText(data?.tasks[0]?.date_end) : "Unlimited"}</b>
								</a>

								<a>
									<span>ملاحظات</span>
									<b>{data?.tasks[0]?.full ? data?.tasks[0]?.full : "--"}</b>
								</a>


							</div>
						</div>
					</div>


						
					
					
				</div>


			</div>

			<Footer />
		</>
	)
	
}
